import CookieNotice from "./CookieNotice";

export default CookieNotice;
